<template>
  <br />
  <van-cell-group title="" inset>
    <van-field
      left-icon="wap-home"
      v-model="userInfo.hospitalName"
      label="体检机构"
      readonl
    >
    </van-field>
    <van-field
      left-icon="user-o"
      v-model="userInfo.realName"
      label="真实姓名"
      readonly
    />
    <van-field
      left-icon="phone-o"
      v-model="userInfo.phone"
      label="预留手机号"
      readonly
    />
  </van-cell-group>
  <van-form @submit="onSubmit">
    <br />
    <van-slider
      v-model="question.chMedicinePhysVo.pointCount"
      bar-height="2px"
      active-color="#EA6853"
    >
      <template #button>
        <div class="custom-button">
          {{ question.chMedicinePhysVo.pointCount }}
        </div>
      </template>
    </van-slider>
    <br />
    <van-notice-bar
      left-icon="volume-o"
      scrollable
      text="请您从【现象出现的频度】来回答此问卷，预计8分钟完成。"
    />
    <br />
    <van-space direction="vertical" size="2rem" fill>
      <van-row>
        <van-col offset="0.5" span="24">
          <van-cell-group inset>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false"
            >
              第 {{ question.chMedicinePhysVo.point }} 题：{{
                question.chMedicinePhysVo.relQuestion
              }}
            </van-notice-bar>
            <br />
            <van-cell>
              <van-radio-group v-model="question.chMedicinePhysVo.ansCode">
                <van-radio name="1" icon-size="24px">没有</van-radio>
                <br />
                <van-radio name="2" icon-size="24px">很少</van-radio>
                <br />
                <van-radio name="3" icon-size="24px">有时</van-radio>
                <br />
                <van-radio name="4" icon-size="24px">经常</van-radio>
                <br />
                <van-radio name="5" icon-size="24px">总是</van-radio>
              </van-radio-group>
            </van-cell>
          </van-cell-group>
        </van-col>
      </van-row>

      <van-row gutter="20">
        <van-col span="3"></van-col>
        <van-col offset="4" span="8">
          <van-button
            round
            block
            color="linear-gradient(to right, #f67f34, #d55809)"
            native-type="submit"
            @click="getQuePre"
          >
            上一题
          </van-button></van-col
        >
        <van-col span="8">
          <van-button
            round
            block
            color="linear-gradient(to right, #f67f34, #d55809)"
            native-type="submit"
            @click="getQueSave"
          >
            {{ bMessage }}
          </van-button></van-col
        >
      </van-row>
      <van-cell-group inset v-if="showEnd">
        <van-field
          v-model="sms"
          center
          clearable
          label="体质分析"
          placeholder="需要3分钟处理完成。"
          readonly
        >
          <template #button>
            <van-button
              size="small"
              color="linear-gradient(to right, #f67f34, #d55809)"
              to="chmedAnalyse"
              >结果查询</van-button
            >
          </template>
        </van-field>
      </van-cell-group>
    </van-space>
  </van-form>
  <br />
</template>
<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import { getUserInfo } from "../../api/userinfo";
import {
  getChMedInit,
  postUserChPhysDec,
  postUserChPhysDecPre,
} from "../../api/queInfo";
import { postUserLog } from "../../api/userlog";
import { useRouter } from "vue-router";
export default {
  setup() {
    const router = useRouter();
    const ulog = reactive({
      UserLog: {
        path: "",
      },
    });
    const show = ref(false);
    const checked = ref("");
    const bMessage = ref("");
    const value = ref(44.4);
    const showEnd = ref(false);
    const state = reactive({
      userInfo: {
        hospitalName: "",
        area: "",
        realName: "",
        phone: "",
        age: "",
        gender: "",
      },
    });

    const question = reactive({
      chMedicinePhysVo: {
        pointCount: "",
        physCode: "",
        physType: "",
        relQuestion: "",
        point: "",
        ansCode: "",
      },
    });

    const themeVars = reactive({
      fontSizeMd: 32,
    });
    const onChange = (value) => console.log("当前值：" + value);
    //保存
    const getQueSave = () => {
      console.log(question.chMedicinePhysVo.ansCode);
      postUserChPhysDec(question.chMedicinePhysVo).then((res) => {
        console.log(res.data.code);
        if (res.data.code == 0) {
          console.log("成功");
        } else {
          console.log("失败，失败原因:" + res.data.message);
        }
        location.reload();
      });
    };
    //前一题
    const getQuePre = () => {
      postUserChPhysDecPre(question.chMedicinePhysVo).then((res) => {
        console.log(res.data.data);
        question.chMedicinePhysVo = res.data.data;
      });
    };
    onMounted(() => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
      //用户卡信息初始化
      getUserInfo().then((res1) => {
        state.userInfo = res1.data.data;
        console.log(res1.data.data);
      });
      //初始化题目
      getChMedInit().then((res) => {
        question.chMedicinePhysVo = res.data.data;
        if (question.chMedicinePhysVo.point == 81) {
          bMessage.value = "提交";
          if (question.chMedicinePhysVo.ansCode != null) {
            showEnd.value = true;
          }
        } else {
          bMessage.value = "下一题";
        }
        console.log(question.chMedicinePhysVo);
      });
    });
    return {
      ref,
      show,
      checked,
      themeVars,
      question,
      bMessage,
      value,
      showEnd,
      onChange,
      getQueSave,
      getQuePre,
      ...toRefs(state),
    };
  },
};
</script>
<style>
.custom-button {
  width: 26px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: var(--van-warning-color);
  border-radius: 100px;
}
</style>
